import { render, staticRenderFns } from "./BreakinCupo.vue?vue&type=template&id=08e6f7f2"
import script from "./BreakinCupo.vue?vue&type=script&lang=js"
export * from "./BreakinCupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports